(function ( $ ) {
	$.fn.school_list = function ( options ) {
		options = $.extend({
			max_count_on_line: 1,
			on_page: 3
		}, options);

		var make = function () {
			var self       = this,	// перепишем объект
			    mql        = window.matchMedia('all and (max-width: 1000px)'),
			    is_mobile  = mql.matches,
			    news_itm   = $(self).find('.news_block_item'),
			    news_list  = $(self).find('.events_block__news_list'),
			    page_count = news_itm.length,
			    news_itm_width;

			$(document).ready(function () {

				init();

				function init() {
					var padding     = 35,
					    on_page     = options.on_page;

					if( is_mobile ) {
						on_page = 1;
						padding = 30;
						news_itm.css('width', 100 / page_count + '%');
					} else{
						news_itm.css('width', 100 / on_page + '%');

					}

					news_list.css('width', page_count * 100 + '%');
					news_list.attr('data-page', 0);
					news_list.css('transform', 'translateX(0)');

					visible_news_btn(0);

					news_itm_width = news_itm.width() + (padding * 2);

					if( news_itm.length <= on_page ) {
						$('.news_list_operate .arrow_box_left').css('display', 'none');
						$('.news_list_operate .arrow_box_right').css('display', 'none');
					}

				}

				/**     Управление кнопками     **/

				$(self).find('.news_list_operate .arrow_box_left').click(function () {
					var page = parseInt(news_list.attr('data-page'));
					news_list_slide(page - 1);
				});
				$(self).find('.news_list_operate .arrow_box_right').click(function () {
					var page = parseInt(news_list.attr('data-page'));
					news_list_slide(page + 1);
				});

				function news_list_slide( page ) {
					var on_page  = 1,
					    max_page = page_count - on_page;

					if( page >= 0 && page <= max_page ) {
						var new_pos = news_itm_width * page * -1;

						news_list.attr('data-page', page);
						news_list.animate({
							'transform': 'translateX(' + new_pos + 'px)'
						}, 200);

						visible_news_btn(page)
					}
				}


				function visible_news_btn( page ) {
					var on_page  = 1,
					    max_page = page_count - on_page;

					if( page === 0 ) {
						$(self).find('.news_list_operate .arrow_box_left').css('display', 'none');
						$(self).find('.news_list_operate .arrow_box_right').css('display', 'block');

						return true;
					}

					if( page === max_page ) {
						$(self).find('.news_list_operate .arrow_box_left').css('display', 'block');
						$(self).find('.news_list_operate .arrow_box_right').css('display', 'none');

						return true;
					}

					$(self).find('.news_list_operate .arrow_box_left').css('display', 'block');
					$(self).find('.news_list_operate .arrow_box_right').css('display', 'block');
				}


				$(window).resize(function () {
					mql          = window.matchMedia('all and (max-width: 1000px)');

					if( is_mobile !==  mql.matches) //срабатывает в момент перехода.
					{
						is_mobile    = mql.matches;
						init();
					}

				});


				/**     Пролистывание свайпами    **/

				var touchend = 1,  //закончено движение пальцем или нет
				    slider   = news_list,
				    prev;
				slider.on('touchstart click', function ( ev ) {
					if( ev.originalEvent.changedTouches ) prev = ev.originalEvent.changedTouches[0].pageX;   //записываем координаты начального прикосновения
				});
				slider.on('touchmove click', function ( ev ) {
					if( touchend === 1 ) {   //если движение пальцем закончено
						if( ev.originalEvent.changedTouches ) {
							var X = ev.originalEvent.changedTouches[0].pageX;
							if( Math.abs(X - prev) > 120 ) {//слайд совершается только при сильном свайпе
								touchend = 0;
								var page = parseInt(slider.attr('data-page'));
								if( X < prev ) {     //сравниваем текущии координаты с начальным положением пальца
									page++;
								} else {
									page--;
								}
								news_list_slide(page);
							}
						}
					}
				});
				slider.on('touchend click', function ( ev ) {
					touchend = 1;
				});

				/**     /Пролистывание свайпами    **/

			});

		};

		return this.each(make);
	};
})(jQuery);